import { render, staticRenderFns } from "./ContractDocumentsTable.vue?vue&type=template&id=1a1b2bbc&"
import script from "./ContractDocumentsTable.vue?vue&type=script&lang=js&"
export * from "./ContractDocumentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports